import React, { useState, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import { Tooltip as ReactTooltip } from "react-tooltip";
import "./assets/style.css";
import { auth, db } from "./firebase";
import ComplianceMap from "./ComplianceMap";
import firebase from "firebase/compat/app";
import { Element, scroller } from "react-scroll";

const Chapter6_3 = () => {
  const navigate = useNavigate();
  const [selectedAnswers, setSelectedAnswers] = useState({ q1: "", q2: "" });
  const [error, setError] = useState("");
  const [userId, setUserId] = useState(null);

  const questions = [
    {
      question:
        "Frage 1: Welcher Cloud-Sicherheitsstandard wurde vom Bundesamt für Sicherheit in der Informationstechnik (BSI) entwickelt?",
      options: [
        {
          value: "A",
          label: "BSI C5",
        },
        {
          value: "B",
          label: "SOC 2",
        },
      ],
      correct: "A",
    },
    {
      question: "Frage 2: Was prüft die CSA STAR-Zertifizierung?",
      options: [
        {
          value: "A",
          label: "Die finanzielle Stabilität von Cloud-Anbietern.",
        },
        {
          value: "B",
          label:
            "Die Sicherheitsmaßnahmen von Cloud-Anbietern auf Basis der Cloud Security Alliance (CSA) Vorgaben.",
        },
      ],
      correct: "B",
    },
  ];
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      scroller.scrollTo(location.hash.substring(1), {
        duration: 500,
        smooth: true,
        offset: -50,
      });
    }
  }, [location]);
  
  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((user) => {
      if (user) {
        setUserId(user.uid); 
      } else {
        console.error("Kein authentifizierter Benutzer gefunden");
        setError("Benutzer ist nicht authentifiziert");
        navigate("/cybersecurity/login"); 
      }
    });

    
    return () => unsubscribe();
  }, [navigate]);

  
  useEffect(() => {
    console.log("Aktuelle userId in 6_3.js:", userId);
  }, [userId]);

  const handleLogout = () => {
    
    auth
      .signOut()
      .then(() => {
       
        window.location.href = "/login"; 
      })
      .catch((error) => {
        console.error("Logout fehlgeschlagen:", error);
      });
  };

  const handleAnswerChange = (questionIndex, value) => {
    setSelectedAnswers((prev) => ({
      ...prev,
      [questionIndex]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const correctAnswers = questions.every(
      (q, index) => selectedAnswers[index] === q.correct
    );

    if (correctAnswers) {
      try {
        if (!userId) {
          console.error("userId ist nicht definiert");
          setError("Ein Fehler ist aufgetreten.");
          return;
        }

        
        const userDoc = await db.collection("cybersecurityProgress").doc(userId).get();

        console.log("userDoc:", userDoc.exists); 

        if (userDoc.exists) {
          
          await db
            .collection("cybersecurityProgress")
            .doc(userId)
            .update({
              lastChapter: "6_3",
              completedChapters:
                firebase.firestore.FieldValue.arrayUnion("6_3"),
            });
          console.log("Dokument aktualisiert mit Kapitel 6_3.");
        } else {
         
          await db
            .collection("cybersecurityProgress")
            .doc(userId)
            .set({
              lastChapter: "6_3",
              completedChapters: ["6_3"],
            });
          console.log("Dokument erstellt mit Kapitel 6_3");
        }

        navigate("/cybersecurity/6_4"); 
      } catch (error) {
        console.error("Fehler beim Aktualisieren des Fortschritts:", error);
        setError("Ein Fehler ist aufgetreten. Versuche es später erneut.");
      }
    } else {
      setError("Die Antworten sind nicht korrekt. Versuche es erneut.");
    }
  };
  return (
    <div className="container">
      <div className="container py-5">
        <img
          src="/images/zebbs_Logo.svg"
          class="d-block mx-auto mb-4"
          alt=""
          style={{ width: "20%" }}
        />
        <div className="d-flex justify-content-between align-items-center mb-5 p-3 bg-body-tertiary rounded-3">
          {/* Breadcrumbs */}
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb breadcrumb-chevron mb-0">
              {/* Startseite (Home) */}
              <li className="breadcrumb-item">
                <Link className="link-body-emphasis" to="/cybersecurity/course-overview">
                  <i className="bi bi-house-door-fill"></i>
                  <span className="visually-hidden">Home</span>
                </Link>
              </li>

              {/* Library Link */}
              <li className="breadcrumb-item">
                <Link
                  className="link-body-emphasis fw-semibold text-decoration-none"
                  to="/cybersecurity/course-overview"
                >
                  6. Sicheres Cloud Computing
                </Link>
              </li>

              {/* Aktuelle Seite */}
              <li className="breadcrumb-item active" aria-current="page">
                Cloud-Sicherheitsstandards
              </li>
            </ol>
          </nav>

          {/* Logout-Button */}
          <button className="btn btn-outline-dark" onClick={handleLogout}>
            Logout
          </button>
        </div>

        <div
          className="p-5 m-0 rounded-3"
          style={{
            position: "relative",
            backgroundColor: "#009fe0",
            margin: "25px",
            textAlign: "center",
          }}
        >
          <h3 className="text-center p-5">
            Kapitel 6: Sicheres Cloud Computing
          </h3>
          <h2 className="text-center p-3">Cloud-Sicherheitsstandards</h2>
          <img
            src="/images/cloudsicherheit.webp"
            alt="Cloud-Sicherheit"
            style={{ position: "relative", maxWidth: "30%", height: "auto" }}
          />
        </div>
        <div className="white-section">
          <div className="container p-5">
            <h3 className="p-5">Compliance in der Cloud</h3>
            <p className="col-lg-11 text-center mx-auto">
              Compliance in der Cloud umfasst die Einhaltung von Datenschutz-
              und Sicherheitsvorschriften, die auf lokalem, nationalem oder
              internationalem Level gelten. Diese Regularien legen fest, wie
              Daten erhoben, gespeichert, verarbeitet und geschützt werden
              müssen, um die Rechte der betroffenen Personen zu wahren und
              Cyberrisiken zu minimieren. <br />
              <br />
              Die größten Herausforderungen sind dabei die Datenlokalisierung
              (wo dürfen die Daten physisch gespeichert werden),
              Datenschutzvorgaben (wie z. B. die DSGVO in Europa oder HIPAA in
              den USA), sowie spezifische Zertifizierungsanforderungen (z. B.
              ISO 27001). <br />
              <br />
              <strong>
                Rechtskonformität bei internationalen Datenbewegungen:{" "}
              </strong>
              Cloud-Anbieter betreiben Rechenzentren weltweit und verteilt,
              wodurch es schwierig wird sicherzustellen, dass sensible Daten nur
              in den zulässigen Regionen gespeichert werden. Viele gesetzliche
              Regelungen, wie die DSGVO, fordern, dass personenbezogene Daten in
              bestimmten Regionen verbleiben.
              <br />
              <br />
              <strong>Zertifizierungen und Sicherheitsstandards: </strong>
              Viele Branchen verlangen, dass Cloud-Dienste den spezifischen
              Sicherheitsstandards entsprechen, um die Datensicherheit zu
              gewährleisten. Die Zertifizierungen (z. B. ISO 27001) sind oft
              nicht nur eine rechtliche Anforderung, sondern auch ein
              Vertrauensfaktor für Kunden.
              <br />
              <br />
              <strong>Einhaltung von Datenschutzvorgaben: </strong>
              Zu den Anforderungen gehören starke Verschlüsselung,
              Zugriffskontrollen und die Möglichkeit, personenbezogene Daten bei
              Bedarf zu löschen. Besonders für Unternehmen im Finanz- und
              Gesundheitswesen sind spezielle Vorgaben wie B3S relevant, die
              spezielle Sicherheitsmechanismen für sensible Daten fordern.
              <br />
              <br />
              <strong>
                Verantwortlichkeit und Shared Responsibility Model:{" "}
              </strong>
              Compliance in der Cloud bedeutet nicht, dass alle Sicherheits- und
              Datenschutzanforderungen durch den Cloud-Anbieter abgedeckt sind.
              Laut dem Shared Responsibility Model teilen sich Cloud-Anbieter
              und Kunden die Verantwortung, wobei der Anbieter die Sicherheit
              der Cloud-Infrastruktur übernimmt und der Kunde für den korrekten
              Einsatz und Schutz seiner Daten verantwortlich ist.
            </p>

            <h5 className="pt-5">
              <strong>
                Best Practices zur Einhaltung der Compliance in der Cloud:
              </strong>
            </h5>
            <p className="p-3 col-lg-10 text-start mx-auto">
              <section class="pt-5 text-start">
                <ul class="timeline">
                  <li class="timeline-item mb-5">
                    <h5 class="fw-bold">Verständnis der Anforderungen:</h5>

                    <p>
                      Die geltenden Compliance-Vorschriften, Gesetze und
                      Standards (z. B. DSGVO, ISO 27001) kennen und
                      sicherstellen, dass diese auf alle Cloud-Daten und
                      Anwendungen angewendet werden.
                    </p>
                  </li>

                  <li class="timeline-item mb-5">
                    <h5 class="fw-bold">Datenlokalisierung:</h5>

                    <p>
                      Sensible Daten nur in zulässigen Regionen speichern.{" "}
                      <span
                        data-tooltip-id="tooltip-geo"
                        data-tooltip-content="Geofencing ist eine Technologie, die auf geografischen Begrenzungen basiert und mithilfe von GPS, RFID, WLAN oder Mobilfunkdaten virtuelle Zonen erstellt. Sobald ein Gerät (wie ein Smartphone oder ein IoT-Gerät) eine solche Zone betritt oder verlässt, wird ein vordefinierter Trigger aktiviert, z. B. eine Benachrichtigung, Warnung oder eine automatisierte Aktion. Im Cloud-Computing und Compliance-Kontext wird Geofencing oft verwendet, um sicherzustellen, dass Daten nur in bestimmten Regionen gespeichert oder abgerufen werden, um lokale Datenschutz- und Compliance-Anforderungen zu erfüllen."
                        className="custom-tooltip-trigger"
                      >
                        Geofencing{" "}
                      </span>{" "}
                      nutzen und Cloud-Anbieter wählen, die Rechenzentren in den
                      erforderlichen Ländern bereitstellen, um die
                      Datenlokalisierung sicherzustellen.
                    </p>
                  </li>

                  <li class="timeline-item mb-5">
                    <h5 class="fw-bold">Audits und Compliance-Checks:</h5>

                    <p>
                      Regelmäßige Audits und Compliance-Prüfungen durchführen,
                      um die Einhaltung der Standards sicherzustellen.
                      Sicherheitsmaßnahmen und Datenschutzrichtlinien
                      dokumentieren, um Compliance-Nachweise bei Bedarf vorlegen
                      zu können.
                    </p>
                  </li>

                  <li class="timeline-item mb-5">
                    <h5 class="fw-bold">Mitarbeiterschulung:</h5>

                    <p>
                      Mitarbeiter für Compliance-Themen sensibilisieren und
                      sicherstellen, dass alle Benutzer die
                      Datenschutzanforderungen verstehen. Dies reduziert das
                      Risiko von Fehlern, die zu Compliance-Verstößen führen
                      könnten.
                    </p>
                  </li>

                  <li class="timeline-item mb-5">
                    <h5 class="fw-bold">Automatisierte Überwachung:</h5>

                    <p>
                      Cloud Security Posture Management (CSPM)-Lösungen
                      einsetzen, um Konfigurationsabweichungen und Verstöße
                      gegen Sicherheitsrichtlinien zu erkennen. CSPM überwachen
                      automatisch die Cloud-Umgebungen, erkennen
                      Sicherheitsrisiken und beheben Fehlkonfigurationen (z. B.
                      öffentliche Buckets). CSPM-Lösungen sind z. B. AWS
                      Security Hub, Microsoft Defender for Cloud, Palo Alto
                      Prisma Cloud oder Check Point CloudGare.
                    </p>
                  </li>
                  <li class="timeline-item mb-5">
                    <h5 class="fw-bold">
                      Cloud-Anbieter mit Zertifizierungen:
                    </h5>

                    <p>
                      Anbieter mit Sicherheits- und Compliance-Zertifizierungen
                      wie ISO 27001, SOC 2 oder{" "}
                      <span
                        data-tooltip-id="tooltip-pcidss"
                        data-tooltip-content="Pflichtstandard für Unternehmen, die Zahlungskartendaten speichern oder verarbeiten."
                        className="custom-tooltip-trigger"
                      >
                        {" "}
                        PCI DSS{" "}
                      </span>{" "}
                      auswählen. Tools wie AWS Artifact oder Azure Compliance
                      Manager nutzen, um die Einhaltung der Vorschriften zu
                      erleichtern.
                    </p>
                  </li>
                  <li class="timeline-item mb-5">
                    <h5 class="fw-bold">Zusätzliche Sicherheitsmaßnahmen:</h5>

                    <p>
                      Die Implementierung von IAM (Identity and Access
                      Management), MFA (Multi-Faktor-Authentifizierung) und
                      Datenverschlüsselung sicherstellen, um den Schutz
                      sensibler Informationen zu gewährleisten.
                    </p>
                  </li>
                </ul>
              </section>
            </p>
            <ReactTooltip
              id="tooltip-pcidss"
              place="top"
              className="custom-tooltip"
            />
            <ReactTooltip
              id="tooltip-geo"
              place="top"
              className="custom-tooltip"
            />

            <p className="col-lg-11 mx-auto">
              Unternehmen müssen sicherstellen, dass ihre Cloud-Dienste alle
              geltenden Vorschriften einhalten, was sich zunehmend als
              Herausforderung darstellt, da gesetzliche Anforderungen oft
              umfangreich und regional unterschiedlich sind.
            </p>
            <p className="col-lg-9 mx-auto d-inline-flex p-5 m-5 text-decoration-none border-danger rounded-2">
              <img
                src="/images/fact.svg"
                alt="Transparent"
                style={{
                  position: "relative",
                  maxWidth: "8%",
                  height: "auto",
                }}
              />
              Ein Beispiel für massive Konsequenzen eines Verstoßes gegen
              EU-Regulierungen ist die Verurteilung von Meta 2023. Meta wurde zu
              eine Rekordstrafe von 1,2 Milliarden Euro von der irischen
              Datenschutzbehörde verurteilt. Der Grund waren Verstöße gegen die
              DSGVO: Meta transferierte Daten europäischer Facebook-Nutzer in
              die USA, ohne angemessene Schutzmaßnahmen gegenüber der
              Überwachung durch US-Behörden zu implementieren. Zudem musste Meta
              den Transfer der Daten innerhalb von sechs Monaten einstellen.
            </p>

            <h3 className="pt-5">Compliance-Regularien weltweit</h3>
            <p className="p-3">
              Klicke auf die farbigen Länder für weitere Informationen
            </p>
            <ComplianceMap />
          </div>
        </div>

        <div className="gelb-section">
          <div className="container p-5">
            <div className="p-5 text-center">
              <h2 className="p-4">Cloud-Sicherheitsstandards </h2>
              <p className="col-lg-11 mx-auto">
                Cloud-Sicherheit erfordert einheitliche Standards, um Risiken zu
                minimieren und Compliance-Anforderungen zu erfüllen. Diese
                Standards bündeln bewährte Praktiken aus der Branche und bieten
                eine Orientierung für die Implementierung effektiver
                Sicherheitsmaßnahmen.
              </p>
              <h3 className="p-4">Internationale Sicherheitsstandards </h3>
              <div className="row row-cols-1 row-cols-sm-1 row-cols-md-1 row-cols-lg-2 g-3 p-5">
                <div className="col d-flex align-items-start">
                  <div className="p-3">
                    <img
                      src="/images/standard.png"
                      alt="Transparent"
                      style={{
                        maxWidth: "12%",
                        height: "auto",
                      }}
                    />{" "}
                    <h5 className="m-3">
                      ISO/IEC 27001 – Standard für
                      Informationssicherheitsmanagement (ISMS)
                    </h5>
                    <p className="fs-6 text-start">
                      <ul>
                        <li>
                          Definiert Anforderungen an ein{" "}
                          <strong>
                            {" "}
                            Informationssicherheits-Managementsystem.{" "}
                          </strong>
                        </li>
                        <li>
                          Hilft Unternehmen,{" "}
                          <strong>
                            {" "}
                            Sicherheitsrisiken zu identifizieren und zu
                            minimieren.
                          </strong>
                        </li>
                        <li>
                          Wird von Cloud-Anbietern genutzt, um
                          Sicherheitsmaßnahmen nachzuweisen.
                        </li>
                      </ul>
                    </p>
                  </div>
                </div>
                <div class="col d-flex align-items-start">
                  <div class="p-3">
                    <img
                      src="/images/standard.png"
                      alt="Transparent"
                      style={{
                        maxWidth: "12%",
                        height: "auto",
                      }}
                    />{" "}
                    <h5 class="m-3">
                      ISO/IEC 27017 – Cloud-spezifische Sicherheitskontrollen
                    </h5>
                    <p className="fs-6 text-start">
                      <ul>
                        <li>
                          Erweiterung von ISO 27001 mit zusätzlichen{" "}
                          <strong>
                            Sicherheitsrichtlinien für Cloud-Dienste.
                          </strong>
                        </li>
                        <li>
                          Klärt die{" "}
                          <strong>
                            Verantwortlichkeiten zwischen Cloud-Anbieter und
                            Cloud-Kunde.
                          </strong>
                        </li>
                        <li>
                          Wichtige Themen:{" "}
                          <strong>
                            {" "}
                            Zugriffskontrollen, Verschlüsselung, Schutz
                            virtueller Maschinen.{" "}
                          </strong>
                        </li>
                      </ul>
                    </p>
                  </div>
                </div>
              </div>

              <div className="row row-cols-1 row-cols-sm-1 row-cols-md-1 row-cols-lg-2 g-3 p-5">
                <div className="col d-flex align-items-start">
                  <div className="p-3">
                    <img
                      src="/images/standard.png"
                      alt="Transparent"
                      style={{
                        maxWidth: "12%",
                        height: "auto",
                      }}
                    />{" "}
                    <h5 className="m-3">
                      NIST 800-53 – Sicherheitskontrollen für Cloud-Dienste
                    </h5>
                    <p className="fs-6 text-start">
                      <ul>
                        <li>
                          Beschreibt{" "}
                          <strong>
                            technische Sicherheitsanforderungen für IT-Systeme.
                          </strong>
                        </li>
                        <li>
                          Enthält Richtlinien zu{" "}
                          <strong>
                            Zugriffskontrollen, Verschlüsselung und
                            Netzwerksicherheit.
                          </strong>
                        </li>
                        <li>
                          Wird von US-Behörden und regulierten Branchen genutzt.
                        </li>
                      </ul>
                    </p>
                  </div>
                </div>
                <div class="col d-flex align-items-start">
                  <div class="p-3">
                    <img
                      src="/images/standard.png"
                      alt="Transparent"
                      style={{
                        maxWidth: "12%",
                        height: "auto",
                      }}
                    />{" "}
                    <h5 class="m-3">
                      Cloud Security Alliance (CSA) – Organisation für
                      Cloud-Sicherheit
                    </h5>
                    <p className="fs-6 text-start">
                      <ul>
                        <li>
                          Internationale Vereinigung, die{" "}
                          <strong>Best Practices für Cloud-Sicherheit</strong>{" "}
                          entwickelt.
                        </li>
                        <li>
                          Bietet Unternehmen Leitlinien für{" "}
                          <strong>sichere Cloud-Architekturen.</strong>
                        </li>
                        <li>
                          Entwickelte das{" "}
                          <strong>Cloud Controls Matrix (CCM)</strong> zur
                          Risikobewertung.
                        </li>
                      </ul>
                    </p>
                  </div>
                </div>
              </div>

              <div className="row row-cols-1 row-cols-sm-1 row-cols-md-1 row-cols-lg-2 g-3 p-5">
                <div className="col d-flex align-items-start">
                  <div className="p-3">
                    <img
                      src="/images/standard.png"
                      alt="Transparent"
                      style={{
                        maxWidth: "12%",
                        height: "auto",
                      }}
                    />{" "}
                    <h5 className="m-3">
                      CSA STAR-Zertifizierung – Sicherheitsnachweis für
                      Cloud-Anbieter
                    </h5>
                    <p className="fs-6 text-start">
                      <ul>
                        <li>
                          Bewertet die Sicherheitsmaßnahmen von{" "}
                          <strong>Cloud-Dienstleistern.</strong>
                        </li>
                        <li>
                          Drei Stufen:{" "}
                          <strong>
                            Selbstbewertung, unabhängige Zertifizierung,
                            kontinuierliches Monitoring.
                          </strong>
                        </li>
                        <li>
                          Zeigt, dass ein Cloud-Dienst hohe{" "}
                          <strong>Sicherheitsstandards und Compliance</strong>{" "}
                          erfüllt.
                        </li>
                      </ul>
                    </p>
                  </div>
                </div>
                <div class="col d-flex align-items-start">
                  <div class="p-3">
                    <img
                      src="/images/standard.png"
                      alt="Transparent"
                      style={{
                        maxWidth: "12%",
                        height: "auto",
                      }}
                    />{" "}
                    <h5 class="m-3">
                      CIS Controls – Sicherheitsmaßnahmen zur Bedrohungsabwehr
                    </h5>
                    <p className="fs-6 text-start">
                      <ul>
                        <li>
                          Enthält{" "}
                          <strong>18 bewährte Sicherheitsmaßnahmen</strong> für
                          IT- und Cloud-Sicherheit.
                        </li>
                        <li>
                          Fokus auf{" "}
                          <strong>
                            Zugriffsrechte, Systemhärtung, Netzwerksicherheit,
                            Schwachstellenmanagement.
                          </strong>
                        </li>
                        <li>
                          Wird als Grundlage für Cloud-Sicherheitsrichtlinien
                          genutzt.
                        </li>
                      </ul>
                    </p>
                  </div>
                </div>
              </div>

              <div className="row row-cols-1 row-cols-sm-1 row-cols-md-1 row-cols-lg-2 g-3 p-5">
                <div className="col d-flex align-items-start">
                  <div className="p-3">
                    <img
                      src="/images/standard.png"
                      alt="Transparent"
                      style={{
                        maxWidth: "12%",
                        height: "auto",
                      }}
                    />{" "}
                    <h5 className="m-3">
                      CIS Benchmarks – Sicherheitsrichtlinien für
                      Cloud-Plattformen
                    </h5>
                    <p className="fs-6 text-start">
                      <ul>
                        <li>
                          Definiert{" "}
                          <strong>
                            sichere Konfigurationen für AWS, Azure und Google
                            Cloud.
                          </strong>
                        </li>
                        <li>
                          Minimiert Sicherheitsrisiken durch{" "}
                          <strong>konkrete Konfigurationsvorgaben.</strong>
                        </li>
                        <li>
                          Wird von Unternehmen als Standard für{" "}
                          <strong>Cloud-Sicherheitseinstellungen</strong>{" "}
                          verwendet.
                        </li>
                      </ul>
                    </p>
                  </div>
                </div>
                <div class="col d-flex align-items-start">
                  <div class="p-3">
                    <img
                      src="/images/standard.png"
                      alt="Transparent"
                      style={{
                        maxWidth: "12%",
                        height: "auto",
                      }}
                    />{" "}
                    <h5 class="m-3">
                      SOC 2 - Standard zur Sicherheitsprüfung von
                      Cloud-Dienstleistern
                    </h5>
                    <p className="fs-6 text-start">
                      <ul>
                        <li>
                          Ein Sicherheits- und Datenschutzstandard, der von der{" "}
                          <strong>
                            {" "}
                            AICPA (American Institute of Certified Public
                            Accountants){" "}
                          </strong>{" "}
                          entwickelt wurde.
                        </li>
                        <li>
                          Bewertet{" "}
                          <strong>
                            Datenverarbeitung und Sicherheitskontrollen{" "}
                          </strong>{" "}
                          von Cloud-Dienstleistern.
                        </li>
                        <li>
                          Konzentriert sich auf{" "}
                          <strong>
                            {" "}
                            Verfügbarkeit, Integrität, Vertraulichkeit und
                            Datenschutz{" "}
                          </strong>{" "}
                          von Kundendaten.
                        </li>
                      </ul>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="white-section">
          <div className="container p-5">
            <div className="p-5 text-center">
              <h2 className="p-5">
                Cloud-Sicherheitsstandards für Unternehmen in Deutschland
              </h2>

              <div className="row row-cols-1 row-cols-sm-1 row-cols-md-2 row-cols-lg-2 g-3 p-5">
                <div className="col d-flex align-items-start">
                  <div className="p-3">
                    <img
                      src="/images/standard.png"
                      alt="Transparent"
                      style={{
                        maxWidth: "12%",
                        height: "auto",
                      }}
                    />{" "}
                    <h5 className="m-3">
                      BSI IT-Grundschutz – Sicherheitsmaßnahmen für Unternehmen
                      & Behörden
                    </h5>
                    <p className="fs-6 text-start">
                      <ul>
                        <li>
                          Entwickelt vom{" "}
                          <strong>
                            Bundesamt für Sicherheit in der Informationstechnik
                            (BSI).
                          </strong>
                        </li>
                        <li>
                          Enthält{" "}
                          <strong>umfassende Sicherheitsrichtlinien</strong> für
                          IT-Systeme, inkl. Cloud-Dienste.
                        </li>
                        <li>
                          Basiert auf ISO 27001, bietet aber{" "}
                          <strong>detailliertere Schutzmaßnahmen.</strong>
                        </li>
                      </ul>
                    </p>
                  </div>
                </div>
                <div class="col d-flex align-items-start">
                  <div class="p-3">
                    <img
                      src="/images/standard.png"
                      alt="Transparent"
                      style={{
                        maxWidth: "12%",
                        height: "auto",
                      }}
                    />{" "}
                    <h5 class="m-3">
                      BSI C5 (Cloud Computing Compliance Criteria Catalogue)
                    </h5>
                    <p className="fs-6 text-start">
                      <ul>
                        <li>
                          Spezialisierter{" "}
                          <strong>Cloud-Sicherheitsstandard des BSI.</strong>
                        </li>
                        <li>
                          Enthält{" "}
                          <strong>
                            Mindestanforderungen für Cloud-Anbieter
                          </strong>
                          , z. B. für{" "}
                          <strong>
                            Datenverschlüsselung, Zugriffskontrollen und
                            Incident Response.
                          </strong>
                        </li>
                        <li>
                          Cloud-Anbieter wie{" "}
                          <strong>AWS, Microsoft Azure und Google Cloud</strong>{" "}
                          sind BSI C5-zertifiziert.
                        </li>
                      </ul>
                    </p>
                  </div>
                </div>
              </div>

              <div className="row row-cols-1 row-cols-sm-1 row-cols-md-1 row-cols-lg-2 g-3 p-5">
                <div className="col d-flex align-items-start">
                  <div className="p-3">
                    <img
                      src="/images/standard.png"
                      alt="Transparent"
                      style={{
                        maxWidth: "12%",
                        height: "auto",
                      }}
                    />{" "}
                    <h5 className="m-3">
                      DSGVO (Datenschutz-Grundverordnung) – Datenschutz in der
                      Cloud
                    </h5>
                    <p className="fs-6 text-start">
                      <ul>
                        <li>
                          EU-Verordnung zur{" "}
                          <strong>
                            Verarbeitung personenbezogener Daten in der Cloud.
                          </strong>
                        </li>
                        <li>
                          Erfordert{" "}
                          <strong>
                            Datenverschlüsselung, Zugriffskontrollen und
                            Löschkonzepte.
                          </strong>
                        </li>
                        <li>
                          Cloud-Nutzer müssen sicherstellen, dass Anbieter{" "}
                          <strong>DSGVO-konform arbeiten.</strong>
                        </li>
                      </ul>
                    </p>
                  </div>
                </div>
                <div class="col d-flex align-items-start">
                  <div class="p-3">
                    <img
                      src="/images/standard.png"
                      alt="Transparent"
                      style={{
                        maxWidth: "12%",
                        height: "auto",
                      }}
                    />{" "}
                    <h5 class="m-3">
                      KRITIS-Verordnung – IT-Sicherheit für kritische
                      Infrastrukturen
                    </h5>
                    <p className="fs-6 text-start">
                      <ul>
                        <li>
                          Betrifft Betreiber von{" "}
                          <strong> kritischen Infrastrukturen </strong> (z. B.
                          Energie, Finanzen, Gesundheitswesen,
                          Telekommunikation).
                        </li>
                        <li>
                          Verpflichtet Unternehmen, spezielle
                          IT-Sicherheitsmaßnahmen und Cloud-Sicherheitskonzepte
                          umzusetzen.
                        </li>
                        <li>
                          Cloud-Anbieter für KRITIS-Unternehmen müssen{" "}
                          <strong>
                            {" "}
                            hohe Verfügbarkeits- und Sicherheitsanforderungen{" "}
                          </strong>{" "}
                          erfüllen.
                        </li>
                      </ul>
                    </p>
                  </div>
                </div>
              </div>

              <div class="row row-cols-1 row-cols-sm-2 row-cols-md-2 row-cols-lg-2 g-3 p-5">
                <div class="col d-flex align-items-start">
                  <div class="p-3">
                    <img
                      src="/images/standard.png"
                      alt="Transparent"
                      style={{
                        maxWidth: "12%",
                        height: "auto",
                      }}
                    />{" "}
                    <h5 class="m-3">
                      MaRisk & BAIT – Vorschriften für Banken und
                      Finanzdienstleister
                    </h5>
                    <p className="fs-6 text-start">
                      <ul>
                        <li>
                          MaRisk (Mindestanforderungen an das Risikomanagement)
                          und BAIT (Bankaufsichtliche Anforderungen an die IT)
                          regulieren IT-Sicherheit im{" "}
                          <strong> Bankensektor. </strong>
                        </li>
                        <li>
                          Banken müssen{" "}
                          <strong>
                            {" "}
                            Cloud-Daten verschlüsseln, Zugriffskontrollen
                            umsetzen und Notfallpläne{" "}
                          </strong>
                          erstellen.
                        </li>
                        <li>
                          Cloud-Dienste für Finanzunternehmen müssen besonders
                          hohe Sicherheits- und Compliance-Anforderungen
                          erfüllen.
                        </li>
                      </ul>
                    </p>
                  </div>
                </div>
                <div class="col d-flex align-items-start">
                  <div class="p-3">
                    <img
                      src="/images/standard.png"
                      alt="Transparent"
                      style={{
                        maxWidth: "12%",
                        height: "auto",
                      }}
                    />{" "}
                    <h5 class="m-3">
                      B3S – Sicherheitsstandards für das Gesundheitswesen
                    </h5>
                    <p className="fs-6 text-start">
                      <ul>
                        <li>
                          Entwickelt für{" "}
                          <strong>
                            {" "}
                            Krankenhäuser und Gesundheitsdienstleister.
                          </strong>{" "}
                        </li>
                        <li>
                          Regelt den{" "}
                          <strong> Schutz von Patientendaten </strong> und
                          medizinischen Systemen in der Cloud.{" "}
                        </li>
                        <li>
                          Cloud-Anbieter für das Gesundheitswesen müssen strenge
                          Datenschutz- und IT-Sicherheitsanforderungen erfüllen.{" "}
                        </li>
                      </ul>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="white-section">
          <div className="container pt-5">
            <div
              className="safe rounded-2 text-center"
              style={{ backgroundColor: "#fec748" }}
            >
              <img
                src="/images/abwehr.svg"
                alt="Abwehr"
                style={{
                  position: "relative",
                  maxWidth: "7%",
                  height: "auto",
                }}
              />
              <h3 className="p-5">
                WAF (Web Application Firewall) in der Cloud
              </h3>
              <Element name="waf">
                <p className="col-lg-11 mx-auto">
                  Eine Webanwendung ist eine Software, die über einen Webbrowser
                  genutzt wird und auf einem Webserver läuft, anstatt lokal auf
                  einem Gerät installiert zu sein. Beispiele sind
                  Online-Banking-Portale oder E-Mail-Dienste wie Gmail, die
                  Nutzer ohne Installation direkt im Browser verwenden können.
                  Da Webanwendungen{" "}
                  <strong> zunehmend in der Cloud gehostet </strong> werden,
                  spielt die <strong> Web Application Firewall (WAF) </strong>{" "}
                  eine zentrale Rolle für die Sicherheit von Cloud-Umgebungen.
                  Eine WAF schützt Webanwendungen und APIs vor gängigen
                  Angriffen wie{" "}
                  <Link to="/cybersecurity/3_3#sql" className="icon-link">
                    <svg className="bi" aria-hidden="true">
                      <use xlinkHref="#book"></use>
                    </svg>{" "}
                    SQL-Injection
                  </Link>
                  und{" "}
                  <Link to="/cybersecurity/3_3#xss" className="icon-link">
                    <svg className="bi" aria-hidden="true">
                      <use xlinkHref="#book"></use>
                    </svg>
                    Cross-Site Scripting (XSS).
                  </Link>{" "}
                  Während traditionelle Firewalls auf Netzwerkebene arbeiten,
                  überwacht und filtert eine WAF gezielt den HTTPS-Datenverkehr
                  bevor er die Web-Anwendung erreicht.
                  <br />
                  <br />
                  Cloud-WAFs sind ideal für Unternehmen, die dynamische
                  Webanwendungen mit minimalem Verwaltungsaufwand schützen
                  wollen. In Cloud-Umgebungen wird eine WAF meist als
                  Cloud-basierter Dienst oder Managed Service bereitgestellt,
                  der zwischen der Anwendung und dem Internet sitzt.
                  <br />
                  <br />
                  Cloud-basierte WAFs bieten mehrere entscheidende Vorteile für
                  die Sicherheit von Webanwendungen. Sie erhalten{" "}
                  <strong>automatische Updates </strong> und erkennen dadurch
                  laufend neue Angriffsmuster, sodass auch unbekannte
                  Bedrohungen abgewehrt werden können. Zudem sind sie{" "}
                  <strong> hoch skalierbar </strong> und passen sich automatisch
                  dem Datenverkehr an, was insbesondere für große und dynamische
                  Webanwendungen wichtig ist. Die{" "}
                  <strong> einfache Integration in Cloud-Umgebungen </strong>{" "}
                  macht sie besonders attraktiv, da viele Cloud-Anbieter wie
                  AWS, Azure und Google Cloud native WAF-Dienste bereitstellen.
                  Zusätzlich bieten sie{" "}
                  <Link to="/cybersecurity/3_4" className="icon-link">
                    {" "}
                    <svg className="bi" aria-hidden="true">
                      {" "}
                      <use xlinkHref="#book"></use>{" "}
                    </svg>{" "}
                    DDoS-Schutz{" "}
                  </Link>
                  durch Mechanismen wie Bot-Erkennung, um massenhafte Anfragen
                  abzuwehren. Bekannte Lösungen wie AWS WAF, Azure WAF und
                  Cloudflare WAF schützen außerdem APIs, sodass nicht nur
                  Webseiten, sondern auch Schnittstellen gegen Angriffe
                  gesichert sind.
                  <br />
                  <br />
                  Darüber hinaus sind <strong>Zero-Day-Angriffe </strong>{" "}
                  (Bedrohungen, die bislang unbekannte Schwachstellen ausnutzen)
                  eine ständige Gefahr in der Cloud. Eine moderne WAF nutzt{" "}
                  <strong> Machine Learning und Anomalieerkennung </strong> ,um
                  ungewöhnliche Aktivitäten frühzeitig zu identifizieren und
                  automatisch Gegenmaßnahmen einzuleiten. Gleichzeitig bieten
                  detaillierte Protokolle und Berichte eine klare Übersicht über
                  Sicherheitsereignisse und unterstützen bei der Einhaltung von
                  Compliance-Richtlinien.
                </p>
              </Element>
            </div>
          </div>

          {/* Fragenteil */}
          <div className="container pt-5 my-5">
            <div className="text-center m-4">
              <h2>Überprüfe dein Wissen</h2>
              <p className="col-lg-11 mx-auto">
                Mit den richtigen Antworten kommst du weiter!
              </p>
            </div>
            <div className="row justify-content-center">
              <div className="col-md-10 text-start">
                <form onSubmit={handleSubmit}>
                  {questions.map((question, index) => (
                    <div key={index} className="mb-4">
                      <p className="fs-4">{question.question}</p>{" "}
                      {question.options.map((option) => (
                        <div key={option.value} className="form-check">
                          <input
                            className="form-check-input me-2"
                            type="radio"
                            name={`question${index}`}
                            value={option.value}
                            checked={selectedAnswers[index] === option.value}
                            onChange={() =>
                              handleAnswerChange(index, option.value)
                            }
                          />
                          <label className="form-check-label fs-5">
                            {option.label}
                          </label>{" "}
                        </div>
                      ))}
                    </div>
                  ))}
                  {error && <p className="text-danger">{error}</p>}
                  <div className="text-center">
                    <button type="submit" className="btn btn-primary">
                      überprüfen
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
          {/* Ende Fragenteil */}
        </div>
      </div>
    </div>
  );
};

export default Chapter6_3;
